var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCw = function SvgCw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c3.938 0 7.432-1.896 9.62-4.825H2.38A11.982 11.982 0 0 0 12 24ZM24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.419.247 2.78.7 4.044h22.6c.453-1.264.7-2.625.7-4.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m8.215 7.696.647 1.993h2.096L9.262 10.92l.648 1.992-1.695-1.231-1.696 1.231.648-1.992-1.695-1.232h2.095l.648-1.993ZM4.615 5.61l.389 1.195H6.26l-1.017.74.389 1.195L4.615 8l-1.017.74.389-1.196-1.017-.739h1.257l.388-1.196Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCw;